import reader from './reader/reducer';
import library from './library/reducer';
import { combineReducers } from 'redux';
import onboarding from './onboarding/reducer';

export default combineReducers({
  reader,
  library,
  onboarding,
});
